var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-lg-6 lbv-device-data" },
        [
          _c(
            "b-card",
            { attrs: { header: "Device Data" } },
            [
              _vm.$store.getters.roleID === "8"
                ? _c("b-table", {
                    attrs: {
                      items: _vm.deviceDataItems,
                      fields: _vm.deviceDataFieldsSimplified,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.roleID !== "8"
                ? _c("b-table", {
                    attrs: {
                      items: _vm.deviceDataItems,
                      fields: _vm.deviceDataFields,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "page prev",
                  attrs: {
                    variant: "primary",
                    size: "sm",
                    disabled: _vm.pageNumber === 1,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.page.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n        Prev\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "page next",
                  attrs: {
                    variant: "primary",
                    size: "sm",
                    disabled: !_vm.hasNextPage,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.page.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n        Next\n      ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "current-page" }, [
                _vm._v(
                  "\n        Page: " + _vm._s(_vm.pageNumber) + "\n      "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("WaterUsage", {
        attrs: { lb_id: _vm.lb_id, device_id: _vm.device_id },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }